import { get } from '../ah-http-service';
import { REGEX_PREFIX_VIEWBEAN } from './utils/constants';

export const getCurrenciesViewBean = async () => {
  const response = await get('/ajax/currency/currencyMap.action', {}, true);
  try {
    if (response?.data) {
      const data = JSON.parse(response.data.replace(REGEX_PREFIX_VIEWBEAN, ''));
      if (data?.viewBeans?.CurrenciesViewBean) {
        return data.viewBeans.CurrenciesViewBean;
      }
    }
    return Promise.reject(
      'malformed response from service currencyMap',
      response
    );
  } catch (error) {
    return Promise.reject(
      'error while parsing response from service currencyMap',
      response?.data || error
    );
  }
};
